import { Component, OnInit, ViewEncapsulation, Input, OnDestroy } from '@angular/core';
import {
  PermanentSaving, Loan, EmployeeRef, LoanParameters, ScheduleDate, BonusInfo, BonusType, LoanBonusApplicableType, LoanScheduleDate,
  Parameter, Employee, PeriodTypeEnum, PayrollParameters, Dictionary, LoanStatus, LoanListItem
} from '@akiba/models_bimbo';
import { Subscription } from 'rxjs';
import { AppState } from 'projects/bimbo/src/app/models/appState';
import { LogicService } from 'projects/bimbo/src/app/services/logic.service';
import { AuthenticationService } from 'projects/bimbo/src/app/services/authentication.service';
import { MatDialog, MatSelectChange, MatSlideToggleChange } from '@angular/material';
import { DataSourceService } from 'projects/bimbo/src/app/services/data-source.service';
import { DatePipe } from '@angular/common';
import { InfoDialogComponent } from 'projects/bimbo/src/app/dialogs/info-dialog/info-dialog.component';
import { CancelConfirmDialogComponent } from 'projects/bimbo/src/app/dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { environment } from 'projects/bimbo/src/environments/environment';
import * as moment from 'moment';
import { UiService } from 'projects/bimbo/src/app/services/ui.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-pl-details',
  templateUrl: './pl-details.component.html',
  styleUrls: ['./pl-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PlDetailsComponent implements OnInit, OnDestroy {

  //////////////////////////////////////
  payrollParameter: PayrollParameters | null = null;
  permanentSavingParameter: Parameter | null = null;
  permanentLoanParameter: LoanParameters | null = null;
  //////////////////////////////////////
  currentEmployee: Employee;
  //////////////////////////////////////

  newLoanTotalInterests = 0;
  newLoanDiscountPerPayment = 0;

  permanentSavings = new PermanentSaving();
  displayedUpFrontColumns: string[] = ['depositDateBiWeek', 'depositDateWeek', 'totalAmount', 'paid'];
  displayedFixedColumns: string[] = ['biWeekNumber', 'weekNumber', 'year', 'capitalAmortization', 'capital', 'interest', 'totalAmount', 'paid'];
  showLoanStatementReport = true;
  showLoanRestructuring = false;
  showLoanAdvancePayment = false;
  showExtraAdvancePayment = false;
  loan: Loan = new Loan();
  loanType: boolean;
  newLoan: Loan = new Loan();
  newLoanType: boolean;

  restucturedMessage = '';

  //////////////////
  defaultRouting = new EmployeeRef();
  //////////////////
  appLogicSubs: Subscription;
  parametersChangedSubs: Subscription;
  //////////////////
  variableLoan: boolean;
  //////////////////
  loanListItem: LoanListItem;
  loanRestructured: any;
  ///* param loan list */
  toDay = new Date();
  loanListParameters: any;
  loanListDates: Array<ScheduleDate>;
  loanListActive: boolean = false;
  sumaPaids = 0;
  //*Bonus types //
  bonusMessage = '';
  newBonusInfo = new BonusInfo({ userLeve: -1, type: LoanBonusApplicableType.capital });
  newBonusPercentage: number = 0;
  oldBonusPercentage: number = 0;
  newKeyBonusPercentage: string;
  newPermanentSavingsBonus: any = {};
  disabledBonus: boolean = true;
  disabledSaving: boolean = false;
  newBonusType: BonusType | null = null;
  newBonusName: string = '';
  /** array para validar tipo de Aportación coalborador y tipo de Aportación en modelos */
  bonusTypes = [
    { id: "annualPerformance", name: "Bono Anual Por Desempeño", percentage: "annualPerformanceBonusPercentage", apply: false },
    { id: "profitSharing", name: "Reparto De Utilidades", percentage: "profitSharingPercentage", apply: true },
    { id: "target", name: "Bono Por Avance de Metas", percentage: "targetBonusPercentage", apply: false },
    { id: "yearEndAndPerformance", name: "Aguinaldo y Bono Anual Por Desempeño", percentage: "yearEndAndPerformanceBonusPercentage", apply: true },
    { id: "veabBonus", name: "Bono VEAB", percentage: "veabBonusPercentage", apply: false }
  ];

  @Input() contentLocation: AppState;
  constructor(public logicService: LogicService, public dialog: MatDialog, private dataService: DataSourceService, private datePipe: DatePipe, private ui: UiService, public authService: AuthenticationService) {

    const parameters = this.logicService.dataManager.parameterDataLoader.parameters ? this.logicService.dataManager.parameterDataLoader.parameters : [];
    const payrollParameters = this.logicService.dataManager.parameterDataLoader.payrolls ? this.logicService.dataManager.parameterDataLoader.payrolls : [];
    this.currentEmployee = this.logicService.dataManager.proxyDataLoader.employee ? this.logicService.dataManager.proxyDataLoader.employee : this.logicService.dataManager.principalDataLoader.employee;

    this.permanentSavingParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.permanentSaving).find(e => e.savingParameterAppliesTo(this.currentEmployee));
    const tempP = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.permanentSaving).find(e => e.loanParameterAppliesTo(this.currentEmployee));
    this.permanentLoanParameter = tempP ? tempP.applicableLoanParameter : null;
    this.payrollParameter = payrollParameters.find(e => e.payrollAppliesTo(this.currentEmployee));

    this.variableLoan = environment.variableLoan;
    this.permanentSavings = this.currentEmployee.permanentSavings && this.currentEmployee.permanentSavings.status === 'active' ? this.currentEmployee.permanentSavings : null;


    if (this.currentEmployee.workInformation.wage.wageName === 'CATORCENAL') {
      this.displayedUpFrontColumns.splice(1, 1);
      this.displayedFixedColumns.splice(1, 1);
    } else {
      this.displayedUpFrontColumns.splice(0, 1);
      this.displayedFixedColumns.splice(0, 1);
    }

    this.loan = new Loan(this.currentEmployee.permanentSavingsLoan.toAny());
    this.loan.scheduleDates = this.currentEmployee.permanentSavingsLoan.scheduleDates;
    this.loanType = this.loan.interestType === 'upFront' || this.loan.interestType === '' ? false : true;

    if (this.loan.status === LoanStatus.ACTIVE_PENDING || this.loan.status === LoanStatus.REVIEW) {
      this.loadLoanListInfo(this.loan.loanID);
      this.loadLoanRestructured(this.loan.loanID);
    }

  }

  ngOnInit() {
    this.getParamLoanList();
    this.disabledBonus = !this.shouldBonus(this.currentEmployee);

  }

  async getParamLoanList() {
    this.loanListParameters = await this.dataService.loadLoanListParameters().pipe(take(1)).toPromise();
    const loanListParamActive = this.loanListParameters.filter(element => element.active === true);
    loanListParamActive.forEach(element => {
      /** si es administrador no importa si est activa o no la fecha o rango de fecha */

      if (this.authService.appLevel && this.authService.appLevel.administrator) {
        this.loanListActive = true;
      }

      element.loanListDates.forEach(e => {
        if (e.endDate && e.startDate) {
          const day: number = this.toDay.getTime();
          let endDate: number = e.endDate.seconds * 1000;
          let startDate: number = e.startDate.seconds * 1000;

          if (e.active) {
            if (startDate <= day && day <= endDate) {
              this.loanListActive = true;
            }
          }
        }
      });
      this.loanListDates = element.loanListDates;
    });
  }

  loanStatementReport() {

    this.newLoan = new Loan();
    this.showLoanStatementReport = true;
    this.showLoanRestructuring = false;
    this.showLoanAdvancePayment = false;
    this.showExtraAdvancePayment = false;

  }

  loanRestructuring() {

    this.newLoan = new Loan();
    this.showLoanStatementReport = false;
    this.showLoanRestructuring = true;
    this.showLoanAdvancePayment = false;
    this.showExtraAdvancePayment = false;

  }

  loanAdvancePayment() {

    this.newLoan = new Loan();
    this.showLoanStatementReport = false;
    this.showLoanRestructuring = false;
    this.showLoanAdvancePayment = true;
    this.showExtraAdvancePayment = false;


  }

  extraAdvancePayment() {
    this.newLoan = new Loan();
    this.showLoanStatementReport = false;
    this.showLoanRestructuring = false;
    this.showLoanAdvancePayment = false;
    this.showExtraAdvancePayment = true;

  }

  async loadLoanListInfo(loanID: string) {

    if (this.loan.status === LoanStatus.ACTIVE_PENDING) {
      const query = await this.dataService.loadEmployeeLoanListItem(loanID).pipe(take(1)).toPromise().catch(error => console.log(error));
      if (query) {
        this.loanListItem = new LoanListItem(query.data());
      }

    }

  }


  async loadLoanRestructured(loanID: string) {
    const query = await this.dataService.loadEmployeeLoanItem(loanID).pipe(take(1)).toPromise().catch(error => console.log(error));
    if (query) {
      this.loanRestructured = query.data();
      this.sumaPaids = await this.isActiveLoan();
    }

  }


  /** restricciones de reestructura */

  shouldAllowRestructuring(employee: Employee, originalLoan: Loan): boolean {

    /** variable parametro de fechas activas al dia actual */
    const permanentLoanParameterDates = this.permanentLoanParameter && this.permanentLoanParameter.loanDates ? this.permanentLoanParameter.loanDates.filter(element => element.active === true && element.startDate <= this.toDay && element.endDate > this.toDay) : [];

    if (permanentLoanParameterDates.length === 0) {
      this.restucturedMessage = 'No es posible solicitar una reestructura ya que se esta fuera del periodo.';
      return true;
    }

    const isTodayPayroll = this.logicService.isTodayAPayrollDayForEmployee(employee);
    if (isTodayPayroll) {
      this.restucturedMessage = 'Existe un candado en este momento por periodo de pagos, inténtelo mas tarde.';
      return isTodayPayroll;
    }

    const payments = employee.permanentSavingsLoan.scheduleDates.values();
    const hasPayments = payments.find(e => e.paid);

    if (!hasPayments) {
      this.restucturedMessage = 'Es necesario que exista al menos un pago entre reestructuras.';
      return true;
    }

    return false;

  }


  /** restricciones de aportaciones extraordinarias, bonos*/
  shouldBonus(employee: Employee): boolean {
    let enableBonus: boolean = true;
    const bonusParam = this.permanentSavingParameter.savingParameter.bonusPercentageForLoan.filter(pd => pd.period.active === true);
    const isTodayPayroll = this.logicService.isTodayAPayrollDayForEmployee(employee);

    for (const iterator of bonusParam) {
      if (iterator.period.startDate <= this.toDay && iterator.period.endDate != null && iterator.period.endDate > this.toDay) {
        enableBonus = false;
      } else if (iterator.period.startDate <= this.toDay && iterator.period.endDate == null) {
        enableBonus = false;
      } else {
        this.bonusMessage = 'En este momento no se puede realizar una aportación';
        enableBonus = true;

      }
    }
 /*       
    if (isTodayPayroll) {
      this.bonusMessage = 'Existe un candado en este momento por periodo de pagos, inténtelo mas tarde.';
      enableBonus = isTodayPayroll;
    }*/
    return enableBonus;

  }

  get showExtraAdvancePaymentComplete(): boolean {
    let bonusActive: Array<any>;
    let status: boolean = false;
    const bonusParam = this.permanentSavingParameter.savingParameter.bonusPercentageForLoan;
    for (const iterator of bonusParam) {
      if (this.loan.bonusPercentage.length > 0) {
        bonusActive = this.loan.bonusPercentage.map(e => e.date).filter(e => e >= iterator.period.startDate && (e <= iterator.period.endDate || iterator.period.endDate == null));
      }
    }
    status = bonusActive && bonusActive.length > 0 ? true : false;
    return status;
  }

  get totalInterest(): number {

    const al = this.loan;
    if (al) {
      if (al.type == 'permanente' && al.interestType !== 'fixed') {
        return al.interestAmount;
      }
    }

    return 0;

  }


  /**
   * return array  tipo de de bono activos.
   */
  get bonusType(): Array<any> {

    const m1 = moment();
    const nowMilSecs = m1.toDate().getTime();
    let newBonus = [];
    // bonos activos en el periodo
    const bonus = this.permanentSavingParameter.savingParameter.bonusPercentageForLoan.filter(pd => pd.period.active === true && pd.period.startDate.getTime() <= nowMilSecs);
    // sindicalizado o no
    let bonusApply: any = this.bonusTypes;
    if (!this.logicService.shouldShowSavingExtras(this.currentEmployee)) {
      bonusApply = this.bonusTypes.filter(e => e.apply === true);
    }

    if ( !this.currentEmployee.isVeabBonusActive ) {
      const veabBonusIndex = bonusApply.findIndex(e => e.id === 'veabBonus');
      if ( veabBonusIndex > -1 ) bonusApply.splice(veabBonusIndex, 1);
    }

    for (const iterator of bonus) {
      // fecha fin aun no termina
      if (iterator.period.endDate == null || iterator.period.endDate.getTime() >= nowMilSecs) {
        for (const elem of bonusApply) {
          if (iterator.bonus === elem.id) {
            newBonus.push(elem);
          }
        }

      }


    }

    return newBonus;
  }

  get firstPaymentDate(): Date | null {
    const al = this.loan;
    if (al) {
      const values = this.loan.scheduleDates.values();
      if (values.length) {
        values.sort((p, n) => p.depositDate.getTime() - n.depositDate.getTime());
        return values[0].depositDate;
      }
    }

    return null;

  }

  get paidTotal(): number {
    const al = this.loan;
    if (al) {
      const total = al.scheduleDates.values().filter(element => element.paid).map(element => element.capital).reduce(((prev, next) => next ? prev + next : 0), 0);
      return total;
    }

    return 0;
  }


  /**
   * suma las pagas del colaborador para saber cual es el monto que aun le falta por pagar
   */
  get pendingTotal(): number {
    const al = this.loan;
    if (al) {
      const pending = al.scheduleDates.values().filter(element => !element.paid).map(element => element.capital).reduce(((prev, next) => next ? prev + next : prev), 0);
      return pending;
    }

    return 0;
  }


  /** esta funcion fue el cambio de tipo nole hagas caso  */
  get remainingPayments(): number {

    const al = this.loan;
    if (al) {
      const pending = al.scheduleDates.values().filter(element => !element.paid).length;
      return pending;
    }

    return 0;

  }

  get prepaymentInterest(): number {

    const remAmount = this.pendingTotal;
    const remPayments = (this.remainingPayments - 1);
    const remInt = this.loan.interestPercentage;
    const calc = (remAmount * remInt * remPayments);
    this.newLoan.prepaymentInterest = calc;
    return this.newLoan.prepaymentInterest;

  }

  get remainderPayment(): number {
    const total = this.pendingTotal;
    return total;
  }

  get nextPaymentDate(): Date {
    const dp = this.loan.scheduleDates.values().find(element => !element.paid);
    if (dp) {
      return dp.depositDate;
    }
    return new Date();
  }

  get savingsTotal(): number {

    if (this.currentEmployee.permanentSavings) {

      const total = this.currentEmployee.permanentSavings.total;
      const totalE = this.currentEmployee.permanentSavings.totalExtras;
      const totalW = this.currentEmployee.permanentSavings.totalWithdrawals;
      return (total + totalE) - totalW;

    }
    return 0;
  }

  get maxLoanAmount(): number {
    return this.permanentLoanParameter.maxLoanAmount(this.currentEmployee, this.logicService.shouldCalculateAVGWage(this.currentEmployee));
  }

  get loanInterest(): number {
    return this.permanentLoanParameter.loanInterest(this.currentEmployee);
  }

  get maxNumberOfPayments(): number {
    const maxPayments : number = this.permanentLoanParameter.maxNumberOfPayments(this.currentEmployee);

    if (this.permanentLoanParameter.dateMaxPayments) {
      const m1 = moment();
      const dateMaxPayments = this.permanentLoanParameter.dateMaxPayments.getTime();
      const nowMilSecs = m1.toDate().getTime();
      const nextPaymentsLimit = this.payrollParameter.payrollDatesForLoans.filter(pd => pd.active === true && pd.startDate.getTime() >= nowMilSecs && pd.startDate.getTime() <= dateMaxPayments);      

      if (nextPaymentsLimit.length >= maxPayments || nextPaymentsLimit.length == 0) {
        return maxPayments;
      } else {
        return nextPaymentsLimit.length;
      }
    } else {
      return maxPayments;
    }
  }

  get discountPerPayment(): number {
    if (this.newLoan.amountToDiscountPerPaymentCycle) {
      return this.newLoan.amountToDiscountPerPaymentCycle;
    } else {
      return this.newLoan.requestedAmount && this.newLoan.requestedNumberOfPayments ? (this.newLoan.requestedAmount / this.newLoan.requestedNumberOfPayments) : 0;
    }
  }

  get scheduleDatesValues(): Array<LoanScheduleDate> {
    const values = this.loan.scheduleDates.values();
    values.sort((p, n) => p.depositDate.getTime() - n.depositDate.getTime());
    return values;
  }

  calculate() {

    if (this.newLoan.requestedAmount === 0) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el monto sea mayor a 0',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.newLoan.requestedAmount <= this.remainderPayment) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el monto sea mayor a $ ' + this.remainderPayment.toFixed(2),
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.newLoan.requestedNumberOfPayments < 2) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el número de cuotas sea mayor a 1',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.newLoan.requestedNumberOfPayments > this.maxNumberOfPayments) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el número de cuotas sea menor al máximo número de cuotas',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.newLoan.requestedAmount > this.maxLoanAmount) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El monto solicitado excede el máximo monto permitido.',
          close: 'Aceptar'
        }
      });

      return;
    }

    const m1 = moment();
    const nowMilSecs = m1.toDate().getTime();
    const nextPayments = this.payrollParameter.payrollDatesForLoans.filter(pd => pd.active === true && pd.startDate.getTime() >= nowMilSecs);

    this.newLoan = this.permanentLoanParameter.calculateLoan(this.variableLoan, this.currentEmployee, this.newLoan.requestedNumberOfPayments, this.newLoan.requestedAmount, this.loanInterest, this.payrollParameter, nextPayments);
    this.newLoanType = this.newLoan.interestType === 'upFront' || this.newLoan.interestType === '' ? false : true;

    if (this.loanType) {
      this.newLoan.prepaymentInterest = 0;
    }

    const thirtyPercentRule = (0.30 * this.currentEmployee.periodWage);
    const wageLiq = (0.30 * this.currentEmployee.wageLiquidity);
    let max: number;

    if (thirtyPercentRule > 0 && wageLiq > 0) {
      max = Math.max(thirtyPercentRule, wageLiq);
    } else {
      max = 0;
    }

    if (max < this.discountPerPayment) {

      this.newLoan.scheduleDates = new Dictionary<LoanScheduleDate>(LoanScheduleDate);

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El monto de las cuotas a pagar excederían tu capacidad de pago, tu capacidad de pago por cuota es de: $ ' + max.toFixed(2),
          close: 'Aceptar'
        }
      });
      return;

    }

  }

  saveRestructuredLoan() {
    
    if (this.newLoan.requestedAmount === 0) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el monto sea mayor a 0',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.newLoan.requestedAmount <= this.remainderPayment) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el monto sea mayor a $ ' + this.remainderPayment.toFixed(2),
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.newLoan.requestedNumberOfPayments < 2) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el número de cuotas sea mayor a 1',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.newLoan.requestedNumberOfPayments > this.maxNumberOfPayments) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el número de cuotas sea menor al máximo número de cuotas',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.newLoan.requestedAmount > this.maxLoanAmount) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El monto solicitado excede el máximo monto permitido.',
          close: 'Aceptar'
        }
      });

      return;
    }

    if (this.newLoan.scheduleDates.values().length < 2) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el número de cuotas sea mayor a 1',
          close: 'Aceptar'
        }
      });

      return;

    }

    const newLoan = new Loan(this.newLoan.toAny());
    
    const sd: any = this.newLoan.scheduleDates.toObject();
    const keys = Object.keys(sd);
    for (const key of keys) {
      const scheduleDate = new LoanScheduleDate(sd[key]);
      newLoan.scheduleDates.add(key, scheduleDate);
    }

    if (newLoan.scheduleDates.values().length > 0) {

      const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
        data: {
          message: `¿Desea liquidar su préstamo en la siguiente paga, así como solicitar un nuevo préstamo?`,
          cancelButton: 'Cancelar',
          confirmButton: 'Aceptar'
        }
      });

      dialogConfirmation.afterClosed().subscribe(result => {
        if (result) {

          this.ui.showSpinner();

          const id = this.loan.loanID;
          this.dataService.markRestructuredLoan(id).then(async () => {

            newLoan.status = LoanStatus.REVIEW;
            newLoan.active = true;
            newLoan.typeID = '01';
            newLoan.type = 'permanent';
            newLoan.employeeRef.employeeNumber = this.currentEmployee.workInformation.employeeNumber;
            newLoan.employeeRef.uid = this.currentEmployee.uid;
            newLoan.employeeRef.email = this.currentEmployee.contactInformation.item('workEmail') ? this.currentEmployee.contactInformation.item('workEmail').value : '';
            newLoan.employeeRef.displayName = this.currentEmployee.displayName;
            newLoan.restructuredID = id;

        if (this.currentEmployee.workInformation && this.currentEmployee.workInformation.supervisor) {

          newLoan.supervisor.employeeNumber = this.currentEmployee.workInformation.supervisor.employeeNumber;
          newLoan.supervisor.email = this.currentEmployee.workInformation.supervisor.email;
          newLoan.supervisor.displayName = this.currentEmployee.workInformation.supervisor.displayName;
          newLoan.supervisor.uid = this.currentEmployee.workInformation.supervisor.employeeNumber;

        }
            
            /**  variable savingAccount si el colaborador es ahorrador o no, validamos si tiene o no caja de ahorro  */
            if (this.currentEmployee.permanentSavings && this.currentEmployee.permanentSavings.active === true) {
              const savingsTotalEnabled: number = Number(((this.currentEmployee.permanentSavings.total + this.currentEmployee.permanentSavings.totalExtras) - this.currentEmployee.permanentSavings.totalWithdrawals).toFixed(2));
              newLoan.employeeRef.activeSavingAccount = savingsTotalEnabled > 0 ? true : false;

            } else {
              newLoan.employeeRef.activeSavingAccount = false;
            }


            const activePeriod = this.permanentSavingParameter;
            if (activePeriod) {
              newLoan.periodId = activePeriod.parametersID;
            }

            const request = newLoan.toAny();
            const sd = newLoan.scheduleDates.toObject();

            request.companyID = this.currentEmployee.workInformation.companyRef.companyID;
            // await this.dataService.updateNotifications(this.currentEmployee.workInformation.supervisor.employeeNumber, 1);
            this.dataService.saveLoanRequest(request, sd).then(() => {
              this.ui.stopSpinner();
              this.dialog.open(InfoDialogComponent, {
                data: {
                  message: 'Los cambios se han guardado exitosamente y la información ha sido enviada a su jefe inmediato para revisión',
                  close: 'Aceptar'
                }
              });
              // this.loanLogic.loan = new Loan();
              this.cancelSimple(1, null);
            });

          }).catch(error => {
            this.ui.stopSpinner();
            console.log(error);
          });
        }
      });

    }

  }

  async isActiveLoan() {
    let sumaPaid = 0;

    if (this.loanRestructured.restructuredID != '') {
      const loadLoan: any = await this.dataService.loadLoan(this.loanRestructured.restructuredID).pipe(take(1)).toPromise().catch(error => {
        console.log(error);
        return [];
      });
      if (loadLoan.status != 'paid' && loadLoan.status != 'withdraw') {
        const cretedAt = loadLoan.createdAt.toDate();
        const interestType = loadLoan.interestType;
        const suma = await this.dataService.loanActiveInPendingList(this.currentEmployee.workInformation.employeeNumber, cretedAt, interestType);

        suma.map(e => {
          sumaPaid = loadLoan.requestedNumberOfPayments < e.longPayments ? 0 : loadLoan.requestedNumberOfPayments - e.longPayments;
        });
      }

    }
    return sumaPaid;
  }


  /**
   * funcion para guardar el pago anticipado del prestamo
   */
  saveAdvanceLoanPayment() {

    /** this.currentEmployee.wageLiquidity liquidez colaborador   */
    if (this.remainderPayment > this.currentEmployee.wageLiquidity) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'No es posible adelantar su pago ya que no se cuenta con la liquidez necesaria.',
          close: 'Aceptar'
        }
      });

      return;
    }


    if (this.loan.scheduleDates.values().length === this.remainderPayment) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'No es posible adelantar su pago ya que es necesario haber realizado un pago.',
          close: 'Aceptar'
        }
      });

      return;
    }

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: `¿Está seguro(a) que desea liquidar $${this.remainderPayment.toFixed(2)} por pago anticipado?`,
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    dialogConfirmation.afterClosed().subscribe(async result => {

      if (result) {
        this.ui.showSpinner();
        this.loan.prepaymentInterest = this.prepaymentInterest;
        this.loan.status = LoanStatus.ADVANCE_PAYMENT;

        const startOfDay = this.loan.convertToCDMXSEC(new Date());
        const transport = this.loan.generateTransportMessage(null);
        const loansArray = Object.keys(transport).map(key => transport[key]).filter(obj => obj);

        this.dataService.markAdvanceLoanPayment(this.loan.loanID).then(() => {
          this.ui.stopSpinner();
          this.dialog.open(InfoDialogComponent, {
            data: {
              message: 'Los cambios se han guardado exitosamente.',
              close: 'Aceptar'
            }
          });
          this.cancelSimple(1, null);
        }).catch(() => {
          this.ui.stopSpinner();
        });
      }
    });
  }

  cancel(tabIndex: number, contentIndex: number | null) {
    const cancelRegistration = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea descartar los cambios hechos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Confirmar'
      }
    });

    cancelRegistration.afterClosed().subscribe(result => {
      if (result) {
        this.contentLocation.tabIndex = tabIndex;
        this.contentLocation.contentIndex = contentIndex;
        this.contentLocation.detailIndex = 0;
        this.loan = this.currentEmployee.permanentSavingsLoan;
      }
    });
  }

  cancelSimple(tabIndex: number, contentIndex: number | null) {
    this.contentLocation.tabIndex = tabIndex;
    this.contentLocation.contentIndex = contentIndex;
    this.contentLocation.detailIndex = 0;
    this.loan = this.currentEmployee.permanentSavingsLoan;
  }

  cancelLoanPending(tabIndex: number, contentIndex: number | null) {

    const authUser = this.logicService.dataManager.principalDataLoader.employee ? this.logicService.dataManager.principalDataLoader.employee : this.authService.authEmployee;
    const messageCancel = `loan canceled by ${authUser.uid} - posicion ${this.loanListItem.listIndex.toString()}`;
    const cancelLoanPending = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: `¿Esta seguro de que desea cancelar el préstamo con número 
        <b> ${this.loanListItem.listIndex.toString()} </b> en Lista de Espera ?`,
        cancelButton: 'Cancelar',
        confirmButton: 'Confirmar'
      }
    });

    cancelLoanPending.afterClosed().subscribe(result => {
      if (result) {
        let createDate = new Date();
        let workInformation = authUser.workInformation;
        let paramLogs = {
          changeID: this.loanListItem.loanID,
          collection: 'employeesLoanList',
          approvedUid: authUser.uid,
          employeeNumber: this.currentEmployee.workInformation.employeeNumber,
          approvedBy: {
            firstName: authUser.firstName,
            firstLastName: authUser.firstLastName,
            employeeNumber: authUser.workInformation.employeeNumber,
          },
          createDate: createDate,
          timeStamp: createDate.getTime()
        };


        this.dataService.markAsRejectedLoan(this.loanListItem.loanID, messageCancel);
        this.dataService.deleteEmployeesLoanList(paramLogs);
        if (this.loanRestructured.restructuredID !== '') {
          if (this.sumaPaids > 0) {
            this.dataService.markDeniedRestructuredLoan(this.loanRestructured.restructuredID);
          }

        }

        this.contentLocation.tabIndex = tabIndex;
        this.contentLocation.contentIndex = contentIndex;
        this.contentLocation.detailIndex = 0;
        this.loan = this.currentEmployee.permanentSavingsLoan;
      }
    });
  }

  /**add bonus 
   *  asignación del porcentaje asignado por el colaborador al bono en caja de ahorro 
   * 
  */
  selectedBonusTypeChange(event: MatSelectChange) {

    if (!event.value) {
      this.newBonusType = null;
      this.newBonusName = '';
      this.newBonusPercentage = 0;
      this.newKeyBonusPercentage = undefined;
      this.newPermanentSavingsBonus = {};
    } else {
      this.newBonusType = event.value;
      this.newBonusInfo.bonus = event.value;
      this.newPermanentSavingsBonus = {};
      for (const type of this.bonusType) {
        if (type.id === this.newBonusType) {
          this.newBonusName = type.name;
          if (this.permanentSavings) {
            this.newKeyBonusPercentage = Object.keys(this.permanentSavings).find(ps => ps == type.percentage) ? Object.keys(this.permanentSavings).find(ps => ps == type.percentage) : this.newBonusInfo.bonus;
            this.newBonusPercentage = this.permanentSavings[this.newKeyBonusPercentage];
            this.oldBonusPercentage = this.permanentSavings[this.newKeyBonusPercentage] ? this.permanentSavings[this.newKeyBonusPercentage] : 0;
            this.disabledSaving = this.newBonusPercentage == 0 ? true : false; this.permanentSavings[this.newBonusInfo.bonus];
            this.newPermanentSavingsBonus[this.newKeyBonusPercentage] = this.newBonusPercentage;
          }
        }
      }
      if (this.permanentSavingParameter.savingParameter.bonusPercentageForLoan) {
        for (const permanentSavingParameter of this.permanentSavingParameter.savingParameter.bonusPercentageForLoan) {
          if (permanentSavingParameter.bonus === event.value) {
            this.newBonusInfo.period = permanentSavingParameter.period;
          }
        }
      }
    }
  }

  bonusInputChanged($event) {

    const intValue = isNaN($event) ? 0 : $event;
    if (this.newKeyBonusPercentage !== undefined && this.newBonusPercentage !== null) {
      this.newPermanentSavingsBonus[this.newKeyBonusPercentage] = this.newBonusPercentage;
    }
    return intValue;
  }

  selectedBonusApplicableType(event: MatSlideToggleChange) {
    if (event.checked == true) {
      this.newBonusInfo.type = LoanBonusApplicableType.payments;

    } else {
      this.newBonusInfo.type = LoanBonusApplicableType.capital;
    }
  }

  /**
   * funcion para guardar en permanentSaving and loanEmployee
   */
  saveBonusExtraAdvance() {
    this.newBonusInfo.percentage = Math.floor(this.newBonusInfo.percentage);
    if (this.newBonusType == null || this.newBonusInfo.bonus == 'notSet') {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Seleccionar un tipo de aportación para su aportación.',
          close: 'Aceptar'
        }
      });

      return;
    }
    /*** porcentage del prestamo en rango*/
    if (this.newBonusInfo.percentage < 1 || this.newBonusInfo.percentage > 100) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'No es posible aportar ese porcentage a su préstamo.',
          close: 'Aceptar'
        }
      });
      return;
    }

    /*** porcentage si tiene caja de ahorro this.permanentSavings !== null 
     * no puede ser menor al registrado anteriormente
     */
    if (this.permanentSavings !== null && this.newBonusPercentage < this.oldBonusPercentage && this.newBonusInfo.percentage + this.newBonusPercentage < 100) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: `El porcentage asignado debe ser superior al registrado en su caja de ahorro: ${this.oldBonusPercentage}%.`,
          close: 'Aceptar'
        }
      });
      return;
    }




    if (this.newBonusInfo.percentage + this.newBonusPercentage > 100) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'La suma de los porcentajes de Aportación a la caja y la Aportación al préstamo no deben superar el 100%',
          close: 'Aceptar'
        }
      });
      return;

    }


    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: `¿Está seguro(a) que desea aportar el  ${Math.floor(this.newBonusInfo.percentage)}% de su bono a su préstamo actual.`,
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    dialogConfirmation.afterClosed().subscribe(async result => {

      if (result) {
        this.ui.showSpinner();
        // save in permanentSavings: bonusPercentageForLoan and percentage in loanEmployee
        let dataBonus: Array<any> = this.newBonusInfo.toAny();
        let permanentObject = this.newPermanentSavingsBonus;
        permanentObject.bonusPercentageForLoan = [dataBonus];
        this.loan.bonusPercentage = [this.newBonusInfo];

        this.dataService.updateLoanBonus(this.loan.loanID, [dataBonus]).then(() => {
          this.ui.stopSpinner();
          /** si tiene caja permanent */
          if (this.permanentSavings !== null) {
            this.dataService.updateBonusPermanentSavings(this.currentEmployee.workInformation.employeeNumber, permanentObject).catch(error => console.log(error));

          }

          this.dialog.open(InfoDialogComponent, {
            data: {
              message: 'Los cambios se han guardado exitosamente.',
              close: 'Aceptar'
            }
          });
          this.cancelSimple(1, null);
        });

      }
    });
  }

  ngOnDestroy(): void {

    if (this.appLogicSubs && !this.appLogicSubs.closed) {
      this.appLogicSubs.unsubscribe();
      this.appLogicSubs = null;
    }

    if (this.appLogicSubs && !this.appLogicSubs.closed) {
      this.appLogicSubs.unsubscribe();
      this.appLogicSubs = null;
    }
    this.loan = new Loan();
    this.newLoan = new Loan();

  }

}
